import React, { memo } from 'react';
import { Modal } from 'react-bootstrap';
import { Button, CloseButton, Flex } from '../primitives';
import SavedSearches from '../SavedSearches';

const ViewSavedSearchesModal = ({ showModal, onClose }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal backdrop="static" show={showModal} onHide={handleClose} className="tv-modal">
      <Modal.Header>
        <Modal.Title>Saved Searches</Modal.Title>
        <CloseButton className="modal-close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Flex direction="column" gap={10}>
          <SavedSearches showDeleteButton />
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(ViewSavedSearchesModal);
